import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cx-header-skipper',
  templateUrl: './header-skipper.component.html',
  styleUrls: ['./header-skipper.component.scss']
})
export class HeaderSkipperComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
